import { inject } from "mobx-react";
import React from "react";
import { useLocation } from "react-router-dom";
import type { Store } from "../../../../client/stores";
import { resolveMenu, SitesMenu } from "../../chrome/Navigation.component";
import type {
    SitesTemplateInfernoMicrositeNavigation,
    SitesTemplateInfernoMicrositeSocial,
} from "../../generated/webapi.g";
import { matchPathByRoutes } from "../../lib/route";
import { MagicLink } from "../../ui";
import styles from "./MicrositeMenu.style.module.scss";

interface MicrositeMenuProps {
    navigation?: SitesTemplateInfernoMicrositeNavigation | null;
    social?: SitesTemplateInfernoMicrositeSocial;
    store?: Store;
}

export const MicrositeMenu = inject("store")(({ navigation, store }: MicrositeMenuProps) => {
    if (!store || !store.microsite || !navigation || !navigation.menu || !navigation.enable_nav_switch) {
        return null;
    }

    const { pathname: fullpath } = useLocation();
    const pathname = fullpath.replace(`/featured/${store.microsite.index!.slug}`, "");

    const routePair = matchPathByRoutes(store.microsite.config.routes, pathname);

    const menu: SitesMenu[] = navigation.enable_nav_switch
        ? navigation.menu
              .filter(Boolean)
              .map(m => resolveMenu({ ...m }, store.env.MICROSITE_ROOT, routePair, store.microsite, {}))
        : [];

    if (menu.length) {
        return (
            <nav className={styles.componentMicrositeMenu}>
                <hr className="divider" />
                <ul className="menu-items">
                    {menu.map((menuItem, i) => (
                        <li key={i}>
                            <MagicLink
                                className={menuItem.active}
                                to={menuItem.href || "#"}
                                target={menuItem.target || "_top"}
                            >
                                {menuItem.label}
                            </MagicLink>
                        </li>
                    ))}
                </ul>
            </nav>
        );
    }
    return null;
});

export default MicrositeMenu;
